module.exports = __webpack_public_path__ + "static/media/programming.498fe7a4.jpg";